

































import {Component, Prop, Vue} from "vue-property-decorator";

@Component({

})
export default class DemandItem extends Vue{

  @Prop({
    type:Object,
    default:()=>{}
  })
  private demandInfo!:any;

}
